<template>
  <ais-refinement-list
    show-more
    :attribute="filter.id"
    :limit="10"
    :show-more-limit="999"
    :transformItems="transformItems"
    :sort-by="sortItems"
    operator="and"
  >
    <template v-slot="{ items, refine, isRefined, isShowingMore, canToggleShowMore, toggleShowMore }">
      <div class="checkbox-filter">
        <div class="filter-values">
          <span v-for="item in items" :key="item.value" class="filter-value-wrapper">
            <input
              :id="filter.id + '-' + slugifyValue(item.value)"
              type="checkbox"
              @click="refine(item.value);"
              :checked="item.isRefined"
            />
            <label :for="filter.id + '-' + slugifyValue(item.value)">
              {{ item.label }}
            </label>
          </span>
        </div>
        <button @click="toggleShowMore" :disabled="!canToggleShowMore" class="show-more">
          {{ !isShowingMore ? 'Show more' : 'Show less' | t }}
        </button>
      </div>
    </template>
  </ais-refinement-list>
</template>

<script>
import t from '../../main/i18n';
import {transformItems} from '../filters-config';

export default {
  props: {
    filter: {type: Object, required: true}
  },
  methods: {
    transformItems(items) {
      return transformItems(this.filter, items);
    },
    slugifyValue(value) {
      return value
        .toString()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '') // eslint-disable-line
        .replace(/\-\-+/g, '-') // eslint-disable-line
        .replace(/^-+/, '')
        .replace(/-+$/, '');
    },
    sortItems(a, b) {
      const aNameFormatted = String(a.name).toLowerCase();
      const bNameFormatted = String(b.name).toLowerCase();

      if (aNameFormatted < bNameFormatted) return -1;
      if (aNameFormatted > bNameFormatted) return 1;

      return 0;
    }
  },
  filters: {
    t
  }
};
</script>
